import React from 'react'
import certifications from '../../data/certifications.json'

export default function CertificationBadges({ className = "" }) {
  return (
    <div className={`grid ${className}`}>
      <div className="flex gap-6 md:gap-8">
        {certifications.map((item) => (
          <a
            key={item.name}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-500 hover:text-slate-400"
          >
            <span className="sr-only">{item.name}</span>
            <img src={item.imgURL} alt={item.name} className="h-20 w-20 md:h-24 md:w-24" />
          </a>
        ))}
      </div>
    </div>
  )
}

// Export the certifications data for potential use elsewhere
export { certifications }
